import React from 'react'
import { connect } from 'react-redux'
import { getMessagesTranslator } from '@layers-frontend/commons/store/selectors/messages'
import { canUseLayi } from '../selectors/users'
import { getLocale } from '../selectors/i18n'
import ChatbotWidget from '../components/ChatbotWidget/ChatbotWidget'

// LAYI is gated on ROLE_WEB_LAYI. This only hides it: the chat service resolves the role itself and
// refuses a session without it, so a user who edits their way past this sees an error, not answers.
export const ChatbotWidgetGate = ({ canUseLayi, ...props }) => (canUseLayi ? <ChatbotWidget {...props} /> : null)

const mapStateToProps = state => ({
  canUseLayi: canUseLayi(state),
  locale: getLocale(state),
  t: getMessagesTranslator(state)
})

export default connect(mapStateToProps)(ChatbotWidgetGate)
